// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItemModal-cls1__cdc23f0ca1ab4a23e688{/*!*/}.CreateSocialItemModal-cls2___dadc5b95a12626c0a52{width:48px;height:48px;border-radius:50%}@media(max-width: 567px){.CreateSocialItemModal-cls2___dadc5b95a12626c0a52{width:40px;height:40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItemModal-cls1__cdc23f0ca1ab4a23e688",
	"cls2": "CreateSocialItemModal-cls2___dadc5b95a12626c0a52 CreateSocialItemModal-cls1__cdc23f0ca1ab4a23e688"
};
export default ___CSS_LOADER_EXPORT___;
